import React from 'react';
export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="svg-logo"
    viewBox="0 0 72 72"
  >
    <g className="column">
      <rect width="24" height="15" transform="skewY(31)" fill="#ffd800" />
      <rect
        width="24"
        height="43"
        transform="translate(0 14) skewY(31)"
        fill="#91d7e8"
      />
      <rect
        width="24"
        height="43"
        transform="translate(0 14) skewY(31)"
        fill="#91d7e8"
      />
      <rect
        width="24"
        height="43"
        transform="translate(0 14) skewY(31)"
        fill="#91d7e8"
      />
    </g>
    <g className="column">
      <rect
        width="24"
        height="34.6"
        transform="translate(24) skewY(31)"
        fill="#891c55"
      />
      <rect
        width="24"
        height="5.76"
        transform="translate(24 33.6) skewY(31)"
        fill="#f99d1c"
      />
      <rect
        width="24"
        height="18.64"
        transform="translate(24 38.36) skewY(31)"
        fill="#f99d1c"
      />
      <rect
        width="24"
        height="18.64"
        transform="translate(24 38.36) skewY(31)"
        fill="#ffd800"
      />
    </g>
    <g className="column">
      <rect
        width="24"
        height="29"
        transform="translate(48) skewY(31)"
        fill="#ffd800"
      />
      <rect
        width="24"
        height="17.8"
        transform="translate(48 28) skewY(31)"
        fill="#f99d1c"
      />
      <rect
        width="24"
        height="12.2"
        transform="translate(48 44.8) skewY(31)"
        fill="#91d7e8"
      />
      <rect
        width="24"
        height="12.2"
        transform="translate(48 44.8) skewY(31)"
        fill="#91d7e8"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/logo.js